import { ElementsHistoryComponent } from './elements-history/elements-history.component';
import { ElementsDeletedComponent } from './elements-deleted/elements-deleted.component';
import { ElementsArchivedComponent } from './elements-archived/elements-archived.component';

import { HistoricoDialogComponent } from './historico-dialog/historico-dialog.component';
import { AttributeJoinCellComponent } from './attributejoin.cell.component';
import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';

import { IdPropertyComponent } from '../customform-editor/idpropertyfield.component';

import { CustomEntityService } from './../../apiclient/api/customEntity.service';
import { UserSessionService } from './../../UserSession/user-session.service';
import { Location } from '@angular/common';
import { ActivatedRoute,Router } from '@angular/router';
import { NbDialogRef, NbDialogService, NbTabComponent, NbTabsetComponent, NbToastrService } from '@nebular/theme';

import { MapQueryService } from '../../map-query.service';
import Map from 'ol/Map';
import Attribution from 'ol/control/Attribution';
import VectorSource from 'ol/source/Vector';
import * as olExtent from 'ol/extent';
import * as olProj from 'ol/proj';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import OSM from 'ol/source/OSM';
import {Style,Fill, Stroke,Circle} from 'ol/style';
import { Point, Polygon, MultiPoint, MultiPolygon } from 'ol/geom';
import {getArea} from 'ol/sphere';
import View from 'ol/View';
import {Draw, Modify, Snap} from 'ol/interaction';
import * as olEventsCondition from 'ol/events/condition';
import LayerSwitcher from 'ol-layerswitcher';
import Feature from 'ol/Feature';
import GeoJSON from 'ol/format/GeoJSON';
import { CustomElementActionsCellComponent } from './custom.element.actions.cell.component';
import { CustomEntityUtils } from './../../custom-entity-utils.service';
import { AttributeJoinViewcellComponent } from './attributejoin.viewcell.component';
import { AttributeTypeCellComponent } from './attributetypecell.components';
import {parseISO,format} from 'date-fns';
import * as moment from 'moment';
import { keyframes } from '@angular/animations';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ChangeDetectionStrategy } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AttributeTypeViewcellComponent } from './attributetype.viewcell.component';

/**
 * Renderiza el componente de Entidades personalizadas
 */
@Component({
  selector: 'ngx-customentity',
  templateUrl: './customentity.component.html',
  styleUrls: ['./customentity.component.scss']
})
export class CustomentityComponent implements OnInit {

  loading: boolean = false;
  loadingLocalidad: boolean = false;
  busquedaLocalidad: string;
  userRole: [String] = ['manager'];
  public reset: any[] = [{}];

  idCustomEntity = "0";
  idCompany ="0";
  customEntites = [];
  customEntityTypes = [];  //Esther F006-EV03
  currentEntity :any = {};
  currentElement :any = {};

  elementsTable: boolean = false;

  elementAttributesArray = [];

  relacionesSimplesArray = [];
  selectedRelacionesSimples:any[];
  relacionesGeospacialesArray = [];
  selectedRelacionesGeospaciales:any[];
  tiposEntidadArray = []; //Esther F006-EV03
  selectedTiposEntidad:any[]; //Esther F006-EV03

  defaultAttributes = [{id:'name',name:'Nombre',type:'text',position:'1'}];

  dropdownSettings = {
    singleSelection: false,
    allowSearchFilter: true,
    searchPlaceholderText:"Buscar",
    enableCheckAll:false,
    textField:"nombre"
  };
  dropdownSettingsTipo = {
    singleSelection: true,
    allowSearchFilter: true,
    searchPlaceholderText:"Buscar",
    enableCheckAll:false,
    textField:"type"
  }; //Esther F006-EV03
  settings = {};  //Esther EV2022-02
  selectedItems = [];  //Esther EV2022-02

  editElements :boolean = false;
  //configuracion mapa
  mapavisible :boolean = false;
  @ViewChild("mapa") mapadiv: ElementRef;
  @ViewChild(ElementsHistoryComponent) historyElements: ElementsHistoryComponent;
  @ViewChild(ElementsDeletedComponent) deletedElements: ElementsDeletedComponent;
  @ViewChild(ElementsArchivedComponent) archivedElements: ElementsArchivedComponent;
  @ViewChild(NbTabsetComponent) tabSet: NbTabsetComponent;
  @ViewChild('autoInput') input;
  @ViewChild('nameField') nameField: ElementRef;
  loadingElement: boolean = false;

  map: Map;
  parcelasSource: VectorSource;
  restoParcelasSource: VectorSource;
  config: any = {
    target: 'visormap',
    center : [0,0]
  };
  parcelaStyle =  new Style({
    stroke: new Stroke({
      color: 'blue',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)',
    }),
  });
  othersParcelaStyle =  new Style({
    stroke: new Stroke({
      color: 'red',
      width: 2.5,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)',
    }),
  });

  verticesStyle = new Style({
    image: new Circle({
      radius: 8,
      fill: new Fill({
        color: 'orange',
      })
    }),
    geometry: function (feature) {
      // return the coordinates of the first ring of the polygon
      var coordinates = feature.getGeometry().getCoordinates()[0];
      return new MultiPoint(coordinates);
    },
  });
  multiVerticesStyle = new Style({
    image: new Circle({
      radius: 8,
      fill: new Fill({
        color: 'orange',
      })
    }),
    geometry: function (feature) {
      // return the coordinates of the first ring of the polygon
      var coordinates = [];
      feature.getGeometry().getCoordinates().forEach(coords => {
        coordinates = coordinates.concat(coords[0]);
      });

      return new MultiPoint(coordinates);
    },
  });
  crearParcelaInteraction: any;

  comboRelacionesSettings ={
    labelKey:"nombre",
    enableCheckAll:false
  };

  entitiesSettings = {
    noDataMessage:"No hay atributos",
    actions: {
      delete: true,
      add: true,
      edit:true,
      position: 'right',
      columnTitle:''
  },

    add: {
      addButtonContent: '<i class="nb-plus"></i><span class="btn-add-text">Nuevo Atributo</span>',
      createButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
      confirmCreate:true,
    },
    edit: {
      editButtonContent: '<i class="far fa-edit small-btn"></i>',
      saveButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
      confirmSave:true,
    },
    delete: {
      deleteButtonContent: '<i class="eva eva-trash-2-outline small-btn"></i>',
      confirmDelete:true,
    },

    columns: {
      id: {
        title: 'ID',
        type: 'text',
        editor: {
          type: 'custom',
          component: IdPropertyComponent,
        }
      },
      position: {
        title: 'Posicion',
        type: 'text',
        sort:true,
        sortDirection:'asc',
        compareFunction:(direction: any, a: any, b: any) => {

          if (+a < +b) {
              return -1 * direction;
          }
          if (+a > +b) {
              return direction;
          }
          return 0;
        },
      },
      name: {
        title: 'Nombre',
        type: 'string',
      },
      type: {
        title: 'Tipo',
        type: 'custom',
        renderComponent: AttributeTypeViewcellComponent,
        editor: {
          type: 'custom',
          component: AttributeTypeCellComponent,
        },

      },
    },
    rowClassFunction: (row) => {

      if(row.data.id != undefined && (row.data.id == 'name' || row.data.id == 'area' )){
        return 'nonremovable blocked-type-selector';
      }
    }
  };

  elementsHistoryAction =
    {
      name: 'historyAction',
      title: '<i class="eva eva-clock-outline" title="Mover a Histórico"></i>'
    };

  elementsSettings = {
    rowClassFunction:(row) => {
      if(row.data.disabledAt == null){
        return 'custom-element'
      }
      return 'custom-element-disabled'
    },
    noDataMessage:'No hay elementos',
    actions: {
      custom:[],
      delete: false,
      add: true,
      edit:true,
      position: 'right',
      columnTitle:''
  },

    add: {
      addButtonContent: '<i class="nb-plus"></i><span class="btn-add-text">Nuevo Elemento</span>',
      createButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
    },
    edit: {
      editButtonContent: '<i class="far fa-edit small-btn"></i>',
      saveButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',

    },
    mode:'external',
    columns: {},
  };

  attributeJoinsSettings = {
    noDataMessage:"No hay relaciones",
    actions: {
      delete: true,
      add: true,
      edit:true,
      position: 'right',
      columnTitle:''
  },

    add: {
      addButtonContent: '<i class="nb-plus"></i><span class="btn-add-text">Nueva Relación</span>',
      createButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
      inputClass:'tienesClase',
      confirmCreate:true,
    },
    edit: {
      editButtonContent: '<i class="far fa-edit small-btn"></i>',
      saveButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
      confirmSave:true,
    },
    delete: {
      deleteButtonContent: '<i class="eva eva-trash-2-outline small-btn"></i>',
    },

    columns: {
      attributeSource: {
        title: 'Atributo',
        type: 'custom',
        renderComponent: AttributeJoinViewcellComponent,
        editor: {
          type: 'custom',
          component: AttributeJoinCellComponent,
        }
      },
      relation: {
        title: 'Relacion',
        type: 'custom',
        renderComponent: AttributeJoinViewcellComponent,

        editor: {
          type: 'custom',
          component: AttributeJoinCellComponent,
        }
      }
    },
  }
  attributeJoinsSource: LocalDataSource = new LocalDataSource();
  source: LocalDataSource = new LocalDataSource();
  elementSource: LocalDataSource = new LocalDataSource();

  urlParams: any;
  savingElement: boolean;
  constructor(
    private userSessionService: UserSessionService,
    private customEntityService: CustomEntityService,
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: NbDialogService,
    private customEntityUtils: CustomEntityUtils,
    private mapQueryService: MapQueryService,
    private toastrService: NbToastrService,
    private nbToastrService: NbToastrService,
  ) {


    this.route.paramMap.subscribe((params) => {
      console.log(params);
      this.urlParams = params;
      this.ngOnInit();
    })
  }

  entitydata: any = {}

  /**
   * @ignore
   */
  public onRecreate() {

  }

  /**
   * @ignore
   */
  ngOnInit(): void {
    this.settings = {
      text: "Compañías",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      labelKey:"nombre",
      singleSelection: false,
      enableSearchFilter: true,
    };  //Esther EV2022-02

    //Cargamos los tipos de entidad - Esther F006-EV03
    this.userSessionService.getCachedCustomEntityTypesFullList().subscribe((entityTypes) =>{
      this.customEntityTypes = JSON.parse(JSON.stringify(entityTypes));
    });

    //Cargamos las entidades



    this.userRole = this.userSessionService.user.acl_roles;

      //revisamos la url por si esta parametrizada


        if (this.tabSet != undefined){
          this.tabSet.selectTab(this.tabSet.tabs.first)
        }


        this.elementsTable = false;
        this.idCompany = this.urlParams.get("idCompany");
        this.idCustomEntity = this.urlParams.get('idEntity');

    this.userSessionService.getCachedCustomEntitiesFullList(this.idCompany).subscribe((entities) =>{
      this.customEntites = JSON.parse(JSON.stringify(entities));

      this.selectedRelacionesGeospaciales = []
      this.selectedRelacionesSimples = []
      this.selectedTiposEntidad = [] //Esther F006-EV03
      this.currentEntity = {};
        if(this.idCustomEntity != '0'){

          //Buscamos la entidad
          const entityFound = this.customEntites.find(entities => entities.id == this.idCustomEntity)
          this.currentEntity = JSON.parse(JSON.stringify(entityFound));
          this.idCompany = this.currentEntity.company_id;
          this.customEntityUtils.editingEntity(this.idCompany,this.idCustomEntity);
          if(undefined != this.historyElements) {
            this.historyElements.ngOnInit()
          }
          if(undefined != this.archivedElements){
            this.archivedElements.ngOnInit()
          }
          if(undefined != this.deletedElements){
            this.deletedElements.ngOnInit()
          }

          //generamos el array de atributos para la smart table y la configuracion de los settings de los elementos
          this.elementsSettings.columns = {};

          this.elementsSettings.actions.custom = [];
          if(this.userRole.includes('superadmin')){
            this.elementsSettings.columns['dependency'] = {
              title: 'Relaciones',
              type:'custom',
              renderComponent: CustomElementActionsCellComponent,
              filter : false,
            };
          }else if(this.currentEntity.history){
            this.elementsSettings.actions.custom.push(this.elementsHistoryAction);
          }
          this.elementsSettings.columns['name'] = { title: 'Nombre', type: 'string' }
          // Ordenar columnas por el atributo pos


          for (let element of entityFound.attributes.sort((a,b)=> {
            const posA = a.position != undefined ? a.position : 9999;
            const posB = b.position != undefined ? b.position : 9999;
            const sort = posA - posB;
            return sort;
          })) {
            this.elementsSettings.columns[element.id] = {title: element.name, type: element.type}
          }

          //parametrizamos la smart table
          this.source = new LocalDataSource();
          this.source.load(entityFound.attributes.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
          this.customEntityUtils.setAttributeList(entityFound.attributes)


        }else{
          //Rellenamos los atributos por defecto

          this.source = new LocalDataSource();
          this.source.load(this.defaultAttributes);
          this.customEntityUtils.editingEntity(this.idCompany,this.idCustomEntity);

          this.customEntityUtils.setAttributeList(this.defaultAttributes)
        }

        //parametrizamos los select
        this.relacionesSimplesArray = [];
        this.customEntites.filter( c => c.company_id == this.idCompany).forEach( element => {
          if(this.idCustomEntity != element.id &&  ( (this.currentEntity.geospatial == true && element.geospatial != true) || (this.currentEntity.geospatial != true) ) ){
            this.relacionesSimplesArray.push({"id": element.id,"nombre":element.name})
          }
        })
        this.relacionesSimplesArray.sort((a,b)=>a.nombre.toLowerCase() < b.nombre.toLowerCase() ? -1 : 1);  //Esther EV2022-02

        this.relacionesGeospacialesArray = [];
        this.customEntites.filter( c => c.company_id == this.idCompany).forEach( element => {
          if(element.geospatial == true && this.idCustomEntity != element.id){
            this.relacionesGeospacialesArray.push({"id": element.id,"nombre":element.name})
          }
        })

        this.relacionesGeospacialesArray.sort((a,b)=>a.nombre.toLowerCase() < b.nombre.toLowerCase() ? -1 : 1)

        this.tiposEntidadArray = []; //Esther F006-EV03
        for (let index = 0; index < this.customEntityTypes.length; index++) {
          const element = this.customEntityTypes[index];
          this.tiposEntidadArray.push({"id": element.id,"type":element.type})
        } //Esther F006-EV03
        this.tiposEntidadArray.sort((a,b)=>a.type.toLowerCase() < b.type.toLowerCase() ? -1 : 1); //Esther F006-EV03


        //Cargamos el valor del tipo de entidad - Esther F006-EV03
        if(this.currentEntity.type != null){
          this.customEntityTypes.forEach(j => {
              if (this.currentEntity.type == j.id){
                  this.selectedTiposEntidad.push(this.tiposEntidadArray.find(r => r.id == j.id))
              }
          });
        }

        //Cargamos los valores de los joins

        if(this.currentEntity.joins != null && this.currentEntity.joins.length > 0){

          this.currentEntity.joins.forEach(j => {
              if (this.relacionesGeospacialesArray.find(rg => rg.id == j) != null){
                  this.selectedRelacionesGeospaciales.push(this.relacionesGeospacialesArray.find(r => r.id == j))
              }else if (this.relacionesSimplesArray.find(rg => rg.id == j) != null){
                this.selectedRelacionesSimples.push(this.relacionesSimplesArray.find(r => r.id == j))
            }
          });
        }

        //cargamos la tabla de elementos
        this.elementAttributesArray = [];

        //Carga los elementos 'normales' Es decir los que no están en el histórico
        //TODO: Tampoco debe cargar los que etén archivados y los que esten eliminados
        if(this.currentEntity.elements != undefined){
          var currentElements = this.currentEntity.elements.filter( e => e.workingfrom == undefined && e.workinguntil == undefined  && e.disabledAt == undefined && e.archivedAt == undefined);

          if(currentElements != undefined){
            for (let index = 0; index < currentElements.length; index++) {
              const element = currentElements[index].attributes;
              let elemento = new Object();

              elemento["attributes"] = currentElements[index].attributes;
              elemento["id"] = currentElements[index].id;
              elemento["name"] = currentElements[index].name;


              //Calcular las dependencias por atributo
              var attributejoins = this.customEntityUtils.calculateAttributeJoins(this.currentEntity,currentElements[index]);
              this.currentEntity.elements[index].joins = this.currentEntity.elements[index].joins.concat(attributejoins)
              let dependencia = currentElements[index].joins.length == 1 ? "dependencia" : "dependencias"
              elemento["dependency"] = currentElements[index].joins.length +" "+ dependencia
              elemento["disabledAt"] = currentElements[index].disabledAt;
              elemento["archivedAt"] = currentElements[index].archivedAt;
              //si la entidad es geospacial
              if(this.currentEntity.geospatial == true){
                elemento["geometry"] = currentElements[index].geometry
              }

              this.currentEntity.attributes.forEach(atr => {
                if(element.find(a => a.id == atr.id) != undefined){
                  elemento[atr.id] = element.find(a => a.id == atr.id).value;
                }
              })

              this.elementAttributesArray.push(elemento)
            }
          }
        }

        //parametrizamos la smart table
        this.elementSource = new LocalDataSource();
        this.elementSource.load(this.elementAttributesArray.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));

        //Cargamos las relaciones por atributo
        this.attributeJoinsSource = new LocalDataSource();
        if(this.currentEntity.attributejoins != undefined && this.currentEntity.attributejoins != null){
          var atributosCargar = this.currentEntity.attributejoins.map(atrjoin => {

            //El atributo fuente
            atrjoin.attributeSource = this.currentEntity.attributes.find(a => a.id == atrjoin.attributeSource);

            atrjoin.entity = this.customEntites.filter( c => c.company_id == this.idCompany).find(e => e.id == atrjoin.entity);
            atrjoin.attributeTarget = this.customEntites.filter( c => c.company_id == this.idCompany).find(e => e.id == atrjoin.entity.id).attributes.find(a => a.id == atrjoin.attributeTarget);
            atrjoin.relation = {entity:atrjoin.entity, attribute: atrjoin.attributeTarget,name:atrjoin.entity.name+'-'+atrjoin.attributeTarget.name }
            delete atrjoin.entity;
            delete atrjoin.attributeTarget;

            return atrjoin;
          })
          this.attributeJoinsSource.load(atributosCargar);
        }


        this.elementsTable = true;
        this.reset[0] = {};
      });


  }

  /**
   * Guarda la entidad
   */
  async guardarEntitdad(){
    let arrayAtributos = []
     var atributos = await this.source.getAll()

     var relacionesAtributo = await this.attributeJoinsSource.getAll();


      this.loading = true
      let entityToSave = JSON.parse(JSON.stringify(this.currentEntity))
      //recorro los atributos
      for (const key in atributos) {
        const element = atributos[key]
        arrayAtributos.push(element)
      }
      entityToSave.attributes = arrayAtributos;


      //TODO: Obtener los attributejoins
      entityToSave.attributejoins = [];
      if(this.selectedTiposEntidad != null && this.selectedTiposEntidad.length >0){
        entityToSave.type = this.selectedTiposEntidad[0].id; // Esther F006-EV03
      }

      //formatear las relaciones simples(devuelve string y es un array de integer)



        entityToSave.joins = [];


      if(entityToSave.geospatial == null){
        entityToSave.geospatial = false;
      }

      if(entityToSave.geospatial && this.idCustomEntity == "0"){
        //Si estamos creando un nueva netidad geoespacial añadimos el atributo area
        arrayAtributos.push({id:'area',name:'Superficie',type:'number','position':2})
      }
    this.selectedRelacionesGeospaciales.forEach(j => {
      if(!entityToSave.joins.includes(Number(j.id))){
        entityToSave.joins.push(Number(j.id))
      }
    })

    this.selectedRelacionesSimples.forEach(j => {
      if(!entityToSave.joins.includes(Number(j.id))){
        entityToSave.joins.push(Number(j.id))
      }
    })

    entityToSave.attributejoins = relacionesAtributo.map(r => {

      return {attributeSource: r.attributeSource.id, entity: r.relation.entity.id,attributeTarget: r.relation.attribute.id}
    })

    if(entityToSave.attributeJoins == null){
      delete entityToSave.attributeJoins;
    }

    if(entityToSave.joins == null){
      delete entityToSave.joins;
    }

    if(entityToSave.type == null){
      delete entityToSave.type;
    }

    delete entityToSave.elements;
     if(this.idCustomEntity == "0"){
        this.customEntityService.createcustomentityByCompany(this.idCompany,entityToSave,this.userSessionService.accessToken).subscribe(async (data) => {
          this.loading = false;
          this.toastrService.success('Guardado con éxito','Guardar')
          this.userSessionService.invalidateCachedCustomEntities();
          this.userSessionService.invalidateCachedCustomEntityTypes();  //Esther F006 EV03 ?
          this.router.navigate(['pages','customentity',data.id])
        });;
      }else{


        this.customEntityService.updatecustomentity(this.idCustomEntity, entityToSave, this.userSessionService.accessToken).subscribe((data) => {
          this.loading = false;
          this.toastrService.success('Guardado con éxito','Guardar')
          this.userSessionService.invalidateCachedCustomEntities()
          this.userSessionService.invalidateCachedCustomEntityTypes()  //Esther F006 EV03 ?
        });
      }


  }

  /**
   * Guarda el elemento en edición de la entidad
   */
  guardarElemento(): void{
    let arrayElementos = [];
    this.elementSource.getElements().then((elementos) =>{
      //recorro los elementos
      for (const key in elementos) {
        const element = elementos[key];
        arrayElementos.push(element.name)
      }
      this.currentEntity.attributes = arrayElementos;

      //comprobamos el elemento
     if(this.idCustomEntity == "0"){
        /*this.customEntityService.createcustomelement(this.currentEntity,this.userSessionService.accessToken).subscribe((data) => {
          this.loading = false;
          console.log(data);
        });*/
      }else{
        /*this.customEntityService.updatecustomelement(this.idCustomEntity, this.currentEntity, this.userSessionService.accessToken).subscribe((data) => {
          this.loading = false;
          console.log(data);
        });*/
      }
    })

    this.ngOnInit();
  }

  /**
   * Inicia la creación de nuevo eleemnto
   * @param event
   */
  crearElemento(event):void{
    this.editElements = true;
    for (let index = 0; index < this.currentEntity.attributes.length; index++) {
      const element = this.currentEntity.attributes[index];
      if (element.type=='text'){
        this.elementsSettings.columns[element.id].listValues = this.currentEntity.elements.map(e => {
          var attri = e.attributes.find(attr => attr.id == element.id);
          if (attri != undefined) return attri.value;
        })
        //Se quitan de la lista los valore duplicados
        this.elementsSettings.columns[element.id].listValues = this.elementsSettings.columns[element.id].listValues.filter((item,index)=>{
          return this.elementsSettings.columns[element.id].listValues.indexOf(item) === index;
        })
      }
    }
    if(this.currentEntity.geospatial){
      this.mapavisible = true
      setTimeout(()=> {
        this.initMap();
        //generia en caso de tener geometria
        this.crearParcela();
        this.pintarRestoGeometriasEntidad();
      },1000);

    }else{
      this.mapavisible = false;
    }
  }

  /**
   * Inicia la edición de un elemento
   * @param event
   */
  editarElemento(event): void{
    this.currentElement = {}
    this.currentElement = JSON.parse(JSON.stringify(event.data));
    this.editElements = true;
    this.loadingElement = true;

    this.currentEntity.attributes.forEach(attribute => {

      this.elementsSettings.columns[attribute.id].listValues = this.currentEntity.elements.filter(e => e.id != this.currentElement.id).map(e => {
        let atributo = e.attributes.find(attr => attr.id == attribute.id);
        if(atributo != undefined) {
          return atributo.value;
        }

      });
      //Se quitan de la lista los valore duplicados
      this.elementsSettings.columns[attribute.id].listValues = this.elementsSettings.columns[attribute.id].listValues.filter((item,index)=>{
        return this.elementsSettings.columns[attribute.id].listValues.indexOf(item) === index;
      })

      if(attribute.type == 'date'){

          if(this.currentElement[attribute.id] != undefined && this.currentElement[attribute.id] != null){
            this.currentElement[attribute.id] = moment(this.currentElement[attribute.id],'YYYY-MM-DD').toDate();
          }


      }

    })

    if(this.currentEntity.geospatial){
      this.mapavisible = true
      setTimeout(()=> {
        this.initMap();
        //generia en caso de tener geometria
        if(this.currentElement.geometry == null || this.currentElement.geometry == undefined){
          this.crearParcela()
        }else{
          this.pintarParcela(this.currentElement.geometry)
          if(this.crearParcelaInteraction != null){
            this.map.removeInteraction(this.crearParcelaInteraction)
          }
          this.pintarRestoGeometriasEntidad();
        }

      },1000);

    }else{
      this.mapavisible = false;
    }

    setTimeout(() => {
      this.nameField.nativeElement.click();
      this.nameField.nativeElement.focus();
      this.nameField.nativeElement.blur();

    },350)

    setTimeout(() => {

      this.loadingElement = false;
    },900)

  }

  /**
   * @ignore
   */
  mostrarElementos() :void{
    this.editElements = false;
    this.currentElement = {}
  }

  /**
   * Actualiza el elemento en edición
   */
  updateElemento():void{
    this.savingElement = true;
    let elemExistente = false;

    //Comprobar valor name
    if(this.currentElement.name == null || this.currentElement.name == ''){
      this.nbToastrService.danger('El atributo '+this.elementsSettings.columns['name'].title+' no puede estar vacío',
        'Error al guardar elemento');
        this.savingElement = false;
        return;
    }

    for (const key in this.currentEntity.elements) {
      if(this.currentElement.name == this.currentEntity.elements[key]['name'] && this.currentElement.id != this.currentEntity.elements[key]['id']){
        elemExistente = true;
      }
    }
    if (elemExistente == false){
      if(this.currentElement.id == undefined){

        let newElement :any = {}
        newElement.name = this.currentElement.name;
        if(this.currentEntity.geospatial){
          newElement.geometry = JSON.stringify(this.obtenerGemetriaDibujada());
        }

        newElement.joins = [];
        newElement.attributes = []
        for (const key in this.currentElement) {
          if(this.currentEntity.attributes.find( a => a.id == key) != undefined){

            let valueToSave = this.currentElement[key];

            if(this.currentEntity.attributes.find( a => a.id == key).type ==  'date' && this.currentElement[key] != null){
              valueToSave = format(this.currentElement[key],'yyyy-MM-dd')
            }
            newElement.attributes[key] = valueToSave;

            newElement.attributes.push({id:key,name:this.currentEntity.attributes.find( a => a.id == key).name,value:this.currentElement[key]})
          }
        }

        this.customEntityService.createcustomelement(parseInt(this.idCustomEntity), newElement, this.userSessionService.accessToken).subscribe((data) => {
          this.loading = false;
          this.savingElement = false;
          this.currentElement = {}
          this.userSessionService.invalidateCachedCustomEntities();
          this.userSessionService.invalidateCachedCustomEntityTypes();  //Esther F006 EV03 ?
          this.mostrarElementos();
        },error => {
          this.savingElement = false;
          if(error.error.message != undefined){
            this.nbToastrService.danger(error.error.message,"Error al guardar elemento");
          }else{
            this.nbToastrService.danger(JSON.stringify(error.error),"Error al guardar elemento");
          }

        });
      }else{
        let idElement = this.currentElement.id.toString();
        let updateElement :any = {}
        updateElement.name = this.currentElement.name;
        if(this.currentEntity.geospatial){
          updateElement.geometry = JSON.stringify(this.obtenerGemetriaDibujada());
        }
        updateElement.joins = [];
        updateElement.attributes = []
        for (const key in this.currentElement) {
          if(this.currentEntity.attributes.find( a => a.id == key) != undefined){

            let valueToSave = this.currentElement[key];

            if(this.currentEntity.attributes.find( a => a.id == key).type ==  'date' && this.currentElement[key] != null){
              valueToSave = format(this.currentElement[key],'yyyy-MM-dd')
            }

            updateElement.attributes.push({id:key,name:this.currentEntity.attributes.find( a => a.id == key).name,value:valueToSave})

          }
        }
        this.customEntityService.updatecustomelement(idElement, updateElement, this.userSessionService.accessToken).subscribe((data) => {
          this.loading = false;
          this.savingElement = false;
          this.currentElement = {}
          this.userSessionService.invalidateCachedCustomEntities();
          this.userSessionService.invalidateCachedCustomEntityTypes();  //Esther F006 EV03 ?
          this.mostrarElementos();
        },error => {
          this.savingElement = false;
          if(error.error.message != undefined){
            this.nbToastrService.danger(error.error.message,"Error al guardar elemento");
          }else{
            this.nbToastrService.danger(JSON.stringify(error.error),"Error al guardar elemento");
          }
        });
      }
    } else {
      this.savingElement = false;
      if(this.currentElement.id == undefined){
        this.nbToastrService.danger("Ya existe un elemento con el mismo nombre","Error al guardar elemento");
      } else {
        this.nbToastrService.danger("Ya existe un elemento con el mismo nombre","Error al modificar elemento");
      }
    }

  }

  /**
   * Elimina el elemento
   * @param event
   */
  deleteElemento(event):void{
    this.customEntityService.deletecustomelement(event.data.id, this.userSessionService.accessToken).subscribe((data) => {
      this.loading = false;
    });
  }

  /**
   * Inicializa el mapa
   */
  initMap() {
    this.mapadiv.nativeElement.innerHTML = "";

    this.parcelasSource = new VectorSource();
    this.restoParcelasSource = new VectorSource();
    const attribution = new Attribution({
      html: 'Teselas de PNOA cedido por � Instituto Geogr�fico Nacional de Espa�a'
    });

    let projection = olProj.get('EPSG:3857');
    let projectionExtent = projection.getExtent();
    //var size = ol.extent.getWidth(projectionExtent) / 512;
    let size = olExtent.getWidth(projectionExtent) / 256;
    let resolutions = new Array(18);
    let matrixIds = new Array(18);
    for (var z = 0; z < 18; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      //matrixIds[z] = "EPSG:4326:" + z;
      matrixIds[z] = z;
    }

    this.map = new Map({
      target: this.config.target,
      layers: [
        new TileLayer({
          source: new OSM(),
          visible:false,
          title: 'Mapa Base',
          type:'base',
        }) ,
        new TileLayer({
          visible:false,
          title: 'Mapa PNOA',
          type:'base',
          source: new WMTS({
            attributions: ['<a href="httpS://www.ign.es" target="_blank">IGN</a>'],
            url: 'http://www.ign.es/wmts/pnoa-ma',
            layer: 'OI.OrthoimageCoverage',
            // matrixSet: 'EPSG:4326',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: olProj.get('EPSG:3857'),
            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds
            }),
            style: [this.parcelaStyle,this.verticesStyle]
          })
        }),
        new TileLayer({
          visible: true,
          title: 'Mapa Geográfico',
          type:'base',
          source: new WMTS({
            attributions:
              'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
              'services/Demographics/USA_Population_Density/MapServer/">ArcGIS</a>',
            url:
              'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/WMTS/',
            layer: '0',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: projection,
            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds,
            }),
            style: 'default',
            wrapX: true,
          }),
        }),
        new VectorLayer({
          source: this.parcelasSource,
        }),
        new VectorLayer({
          visible: true,
          title: `Entidad ${this.currentEntity.name}`,
          source: this.restoParcelasSource,
        }),

      ],
      view: new View({
        center: olProj.fromLonLat(this.config.center),
        zoom: 5,
      })
    });

    var modif =  new Modify({
      source: this.parcelasSource,
      // the SHIFT key must be pressed to delete vertices, so
      // that new vertices can be drawn at the same position
      // of existing vertices
      deleteCondition: function(event) {
        return olEventsCondition.shiftKeyOnly(event) &&
        olEventsCondition.singleClick(event);
      }
    });
    modif.on('modifyend', evt => {
      this.currentElement['area'] = getArea(this.parcelasSource.getFeatures()[0].getGeometry());
    });
    this.map.addInteraction(modif);
      if(typeof this.crearParcelaInteraction != 'undefined'){
        this.map.addInteraction(this.crearParcelaInteraction)
      }else{

      }
      var layerSwitcher = new LayerSwitcher();
      this.map.addControl(layerSwitcher);

  }


  pintarRestoGeometriasEntidad(): void {
    this.customEntityUtils.getCurrentEntity().then(entity => {
        entity.elements.filter(e => e.id != this.currentElement.id &&
           e.workingfrom == undefined && e.workinguntil == undefined  &&
            e.disabledAt == undefined && e.archivedAt == undefined).forEach(element => {
          let field =JSON.parse(JSON.stringify(element.geometry));
          let feature = null;
            if( field.type == 'Polygon'){
              field.coordinates[0] = field.coordinates[0].map(function(coordinate){
                return olProj.fromLonLat(coordinate);
              })

              feature = new Feature({
                geometry: new Polygon(
                  field.coordinates),

                parcela: {name:field.name,region:field.region},
              });
              feature.setStyle(this.othersParcelaStyle);
            }else if(field.type == 'MultiPolygon'){


              field.coordinates = field.coordinates.map(f => {
                  f[0] = f[0].map(function(coordinate){
                    return olProj.fromLonLat(coordinate);
                  })
                  return f;
              });





            feature = new Feature({
              geometry: new MultiPolygon(
                field.coordinates),

              parcela: {name:field.name,region:field.region},
            });
            feature.setStyle(this.othersParcelaStyle);
            }






            this.restoParcelasSource.addFeature(feature);
        });
    });
  }

  /**
   * Activa la creación de geometrías en el mapa
   */
  crearParcela(): void {
    this.crearParcelaInteraction = new Draw({
      source:this.parcelasSource,
      type: 'Polygon',
    })



    this.crearParcelaInteraction.on('drawend', event => {
      this.currentElement.area = getArea(event.feature.getGeometry());
  });

    this.map.addInteraction(this.crearParcelaInteraction);
    this.map.addInteraction(new Snap({source:this.parcelasSource}));
    setTimeout(()=> {
      this.map.getView().setCenter([0.1,0.1]);
      this.map.getView().setZoom(1);
      this.map.updateSize();
    },200)
  }

  /**
   * Pinta parcela en el mapa
   * @param field Parcela
   */
  pintarParcela(field: any): void{
    if(field != null) {
      let feature = null;
      if( field.type == 'Polygon'){
        field.coordinates[0] = field.coordinates[0].map(function(coordinate){
          return olProj.fromLonLat(coordinate);
        })

        feature = new Feature({
          geometry: new Polygon(
            field.coordinates),

          parcela: {name:field.name,region:field.region},
        });
        feature.setStyle([this.parcelaStyle,this.verticesStyle]);
      }else if(field.type == 'MultiPolygon'){


        field.coordinates = field.coordinates.map(f => {
            f[0] = f[0].map(function(coordinate){
              return olProj.fromLonLat(coordinate);
            })
            return f;
        });

        console.log('Tenemos multipolygon');



      feature = new Feature({
        geometry: new MultiPolygon(
          field.coordinates),

        parcela: {name:field.name,region:field.region},
      });
      feature.setStyle([this.parcelaStyle,this.multiVerticesStyle]);
      }






      this.parcelasSource.addFeature(feature);
      this.map.getView().fit(this.parcelasSource.getExtent(),{padding:[100,100,100,100],nearest:true});


    }else{
      setTimeout(()=> {
        this.map.getView().setCenter([0.1,0.1]);
        this.map.getView().setZoom(1);
        this.map.updateSize();
      },200)
    }
  }

  /**
   * Busca la localidad informada por el usuario
   */
  buscarLocalidad(): void{
    this.loadingLocalidad = true;
    this.mapQueryService.queryLocationByAddress(this.busquedaLocalidad).then((locat)=>{
      this.loadingLocalidad = false;
      this.map.setView(new View({
        center: olProj.fromLonLat([locat.lng,locat.lat]),
        zoom: 17,
      }));
    });
  }

  /**
   * Genera un JSON con la geometría dibujada
   * @returns JSON de la geometría
   */
  obtenerGemetriaDibujada(): JSON {
    if(this.parcelasSource != undefined &&  this.parcelasSource.getFeatures().length > 0){
      var geojson = new GeoJSON();


      var geopolygon = JSON.parse(geojson.writeGeometry(this.parcelasSource.getFeatures()[0].getGeometry()))
      if(geopolygon.type == 'MultiPolygon'){
        geopolygon.coordinates = geopolygon.coordinates.map(f => {
          f[0] = f[0].map(function(coordinate){
            return olProj.toLonLat(coordinate);
          })
          return f;
      })



      }else if(geopolygon.type == 'Polygon'){
        geopolygon.coordinates[0] = geopolygon.coordinates[0].map(function(coordinate){
          return olProj.toLonLat(coordinate);
        })
      }


      return geopolygon;
    }
  }


  /**
   * Elimia una entidad
   * @param dialog Diálogo de confirmación
   */
  eliminarEntidad(dialog: TemplateRef<any>):void{
    this.dialogService.open(dialog,{context:this.currentEntity.name});
  }

  /**
   * Confirma la eliminación de la entidad
   */
  confirmarEliminar():void{
    this.customEntityService.deletecustomentity(this.currentEntity.id,this.userSessionService.accessToken).subscribe((result => {
      //this.router.navigate(['pages/customentity/0',{'refresh':(new Date).getTime()}]);
      this.currentEntity = {};
      this.userSessionService.invalidateCachedCustomEntities();
      this.userSessionService.invalidateCachedCustomEntityTypes();  //Esther F006 EV03 ?
      this.router.navigateByUrl('pages/dashboard');
    }));
  }

  /**
   * Elimina un elemento
   * @param dialog Diálogo de confirmación
   */
  eliminarElemento(dialog: TemplateRef<any>):void{

    this.dialogService.open(dialog,{context:this.currentElement});
  }

  /**
   * Confirma la eliminación de un elemento
   */
  confirmarEliminarElemento():void{
    this.customEntityService.deletecustomelement(this.currentElement.id,this.userSessionService.accessToken).subscribe((result => {
      this.userSessionService.invalidateCachedCustomEntities()
      this.userSessionService.invalidateCachedCustomEntityTypes()  //Esther F006 EV03 ?
      this.toastrService.success('El elemento se ha eliminado con éxito','Elemento eliminado')
      this.mostrarElementos();
      this.deletedElements.ngOnInit();
    }));
  }

  /**
   * Restaura un elemento eliminado
   */
  restaurarElemento(): void{
      this.customEntityService.updatecustomelementrestore(this.currentElement.id,this.userSessionService.accessToken).subscribe(result => {
        this.userSessionService.invalidateCachedCustomEntities()
        this.userSessionService.invalidateCachedCustomEntityTypes()  //Esther F006 EV03 ?
        this.toastrService.success('El elemento se ha restaurado con éxito','Elemento restaurado');
        this.mostrarElementos()
        this.deletedElements.ngOnInit();

      })
  }

  /**
   * Archiva un elemento archivado
  */
   archivarElemento(): void{
    this.customEntityService.updatecustomelementhide(this.currentElement.id,this.userSessionService.accessToken).subscribe(result => {
      this.userSessionService.invalidateCachedCustomEntities()
      this.userSessionService.invalidateCachedCustomEntityTypes()  //Esther F006 EV03 ?
      this.toastrService.success('El elemento se ha archivado con éxito','Elemento archivado')
      this.mostrarElementos()
      this.archivedElements.ngOnInit();
    },(error) => {
      this.toastrService.success('Ha ocurrido un error ar archivar el elemento','Archivar elemento')
    })
  }

  /**
   * Desarchiva un elemento archivado
  */
  desarchivarElemento(): void{
    this.customEntityService.updatecustomelementunhide(this.currentElement.id,this.userSessionService.accessToken).subscribe(result => {
      this.userSessionService.invalidateCachedCustomEntities()
      this.userSessionService.invalidateCachedCustomEntityTypes()  //Esther F006 EV03 ?
      this.toastrService.success('El elemento se ha restaurado con éxito','Elemento restaurado');
      this.mostrarElementos()
      this.archivedElements.ngOnInit();

    })
  }

  /**
   * Vuelve a la página anterior
   */
   back(): void{
    this.location.back()
   }


  camelize(str): string  {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '').replace(/\W/g, '_');
  }

  /**
   * Confirma la edición de un registro (campo) del customform
   * @param event
   */
  confirmarFila(event) {

    let idcampo = this.camelize(event.newData.name)
    let idToMatch = idcampo;
    let arrdata = event.source.data
    let nMatches = -1;
    do{
      nMatches ++;

      if(nMatches > 0){
        idToMatch = idcampo+"_"+nMatches;
      }

    }while(arrdata.find(element => element.id == idToMatch))

    event.newData.id = idToMatch;
    console.log(event)

    if(event.newData.name == ""){
      this.nbToastrService.danger("El nombre del atributo es obligatorio","Error al añadir atributo");
      event.confirm.reject()
    }else if(event.newData.type == ""){
      this.nbToastrService.danger("El tipo del atributo es obligatorio","Error al añadir atributo");
      event.confirm.reject()
    }else{
      event.confirm.resolve(event.newData)
      this.actualizaAtributos(event,async(e) => {
        this.attributeJoinsSource.refresh();
      });

    }


  }

  async actualizaAtributos(event,callback){
      await this.source.refresh();
      var attrList = await this.source.getElements();
      this.customEntityUtils.setAttributeList(attrList)

      await callback(event)
  }

  confirmaSaveAttr(event){
    //if(event.newData.id != 'name' && event.newData.id != 'area'){

     event.confirm.resolve(event.newData)
    this.actualizaAtributos(event,async (e) => {
        var attrJoins = await this.attributeJoinsSource.getElements();

        attrJoins.forEach(attr => {
          if(attr.attributeSource.id == e.newData.id){
            attr.attributeSource.name = e.newData.name
          }

        })
        this.attributeJoinsSource.load(attrJoins)
    });
    /*
  }else{
    event.confirm.reject()
    this.nbToastrService.danger("El atributo name no se puede modificar","Error al modificar atributo");
  }
*/
  }

confirmaDelAttr(event){

  if(event.data.id != 'name'){
    event.confirm.resolve(event.data)
    this.actualizaAtributos(event,async (e) => {
      var attrJoins = await this.attributeJoinsSource.getElements();
      attrJoins = attrJoins.filter(attr => attr.attributeSource.id != e.data.id);
      this.attributeJoinsSource.load(attrJoins)
    });
  }else{
    event.confirm.reject()
    this.nbToastrService.danger("El atributo name no se puede eliminar","Error al eliminar atributo");
  }

}
  confirmarRelacion(event){
      if(event.newData.attributeSource == undefined || event.newData.attributeSource == '' ||
      event.newData.relation == undefined || event.newData.relation == null ||
      event.newData.relation.entity == undefined || event.newData.relation.entity == null ||
      event.newData.relation.attribute == undefined || event.newData.relation.attribute == null){
        event.confirm.reject()
        this.nbToastrService.danger("Debe seleccionar todos los elementos","Relación no válida");

      }else{

        event.confirm.resolve(event.newData)
      }
  }

  confirmarNuevaRelacion(event){
    if(event.newData.attributeSource == undefined || event.newData.attributeSource == '' ||
    event.newData.relation == undefined || event.newData.relation == null ||
    event.newData.relation.entity == undefined || event.newData.relation.entity == null ||
    event.newData.relation.attribute == undefined || event.newData.relation.attribute == null){
      event.confirm.reject()
      this.nbToastrService.danger("Debe seleccionar todos los elementos","Relación no válida");

    }else if(event.source.data.find( r => r.attributeSource.id == event.newData.attributeSource.id &&
      r.relation.entity.id == event.newData.relation.entity.id && r.relation.attribute.id == event.newData.relation.attribute.id
      ) != null){
        event.confirm.reject()
      this.nbToastrService.danger("La relación ya existe","Relación no válida");
    }else{

      event.confirm.resolve(event.newData)
    }
  }

  async customActionEvent(event){
    console.log("Acción personalizada")

    switch(event.action){
      case 'historyAction':
        //event.data
        let dialogRef: NbDialogRef<any> = await this.dialogService.open(HistoricoDialogComponent,{context:{elementId : event.data.id},dialogClass: 'model-full'});
        dialogRef.onClose.subscribe(r => {
          this.historyElements.ngOnInit();
        })
      break;
    }
  }

    private filtro(value: string, prop): string[] {
    const filterValue = value.toLowerCase();
    return this.elementsSettings.columns[prop].listValues.filter(optionValue => optionValue.toLowerCase().includes(filterValue));
    }




  }
